import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import AdditionalFilters from './AdditionalFilters'
import BSCard from 'react-bootstrap/Card'
import Loadable from 'react-loadable'
import Nav from 'react-bootstrap/Nav'
import PleaseSupportUs from './PleaseSupportUs'
import Spinner from './Spinner'
import classNames from 'classnames'
import { isPatron } from '../util/helpers'
import { reloadAds } from '../store/pagedata'
import styles from '../styles/CardLists.module.scss'
import useDarkMode from 'use-dark-mode'
import { useParams } from 'react-router-dom'

const Loading = () => (
  <div className={styles.spinner}>
    <Spinner className='fa-3x' />
  </div>
)

const CardView = Loadable({
  loader: () => import('./CardView'),
  loading: Loading,
})
const TableView = Loadable({
  loader: () => import('./TableView'),
  loading: Loading,
})
const TextView = Loadable({
  loader: () => import('./TextView'),
  loading: Loading,
})

const CardLists = () => {
  const darkMode = useDarkMode(false)
  const dispatch = useDispatch()
  const { dir, page, subpage } = useParams()
  const profile = useSelector((state) => state.firebase.profile)
  const [key, setKey] = useState('card')
  const isCombosPage = dir === 'combos' && page && !subpage

  useEffect(() => {
    const layout = JSON.parse(localStorage.getItem('edhrec_layout'))
    if (layout) {
      setKey(layout)
    }
    CardView.preload()
    TableView.preload()
    TextView.preload()
  }, [])

  useEffect(() => {
    localStorage.setItem('edhrec_layout', JSON.stringify(key))
    dispatch(reloadAds())
  }, [key])

  return (
    <>
      <div className='mvCardList'>
        <BSCard
          className={classNames(
            styles.container,
            { [styles.dark]: darkMode.value },
            'shadow-sm'
          )}
        >
          {!isCombosPage && (
            <div className={styles.header}>
              <div className={styles.left}>
                {isPatron(profile) && <AdditionalFilters />}
              </div>
              <div>
                <Nav
                  activeKey={key}
                  className={styles.buttons}
                  onSelect={(k) => {
                    setKey(k)
                  }}
                  variant='pills'
                >
                  <Nav.Item>
                    <Nav.Link eventKey='card'>Card View</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='table'>Table View</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey='text'>Text View</Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
            </div>
          )}
          {isCombosPage || key === 'card' ? (
            <CardView fallback={<Loading />} isCombosPage={isCombosPage} />
          ) : key === 'table' ? (
            <TableView fallback={<Loading />} />
          ) : (
            <TextView fallback={<Loading />} />
          )}
        </BSCard>
        {isPatron(profile) || (
          <div className='mvSidebar1'>
            <PleaseSupportUs />
          </div>
        )}
      </div>
    </>
  )
}

export default CardLists
